import { useSelector } from "react-redux";

import Breadcrumbs from "../../../reusebale/breadcrumbs";
import BankForm from "./bank-form";

const BankMain = ({ onBack }) => {
  const { loginSuccess } = useSelector((state) => state.auth);

  return (
    <div className="mt-6 w-full">
      <Breadcrumbs
        content={`${loginSuccess?.user?.firstName} ${loginSuccess?.user?.lastName}`}
        subheading="My Account"
        onBack={onBack}
      />

      <div className="flex justify-between mt-5">
        <div className="w-full">
          <BankForm onBack={onBack} />
        </div>
      </div>
    </div>
  );
};

export default BankMain;
